import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AvatarService } from '@services/avatar.service';
import Swal from 'sweetalert2';
import { NewavatarComponent } from './newavatar/newavatar.component';
@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {

  languages:any[]=[];
  
  constructor(private modal:NgbModal,private languageService:AvatarService) {
    
      
  }

  ngOnInit(): void {
          this.getLangs();
  }


  getLangs(){
      this.languageService.all().subscribe(res=>{
          this.languages=res;
         
      })
  }


  openSaveModal(){
      const modalref=  this.modal.open(NewavatarComponent, { size: 'lg' });
      
      modalref.result.then((result)=>{
       this.getLangs();
      });
  
      }


  
  detail(data:any){
      const modalref=  this.modal.open(NewavatarComponent, { size: 'lg' });
          modalref.componentInstance.data=data;
      modalref.result.then((result)=>{
       this.getLangs();
      });

  }
  delete(data:any){

      Swal.fire({
          title: 'Dikkat',
          text: "Bu dil silinecek! Onaylıyor musunuz?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Evet',
          cancelButtonText: 'İptal',
        }).then((result) => {

         
          if (result.isConfirmed) {

              this.languageService.delete(data).subscribe(res=>{
                  this.getLangs();
                  Swal.fire(
                      'Başarılı!',
                      'Dil silindi',
                      'success'
                    )
              });
           
          }
        })

  }

}
